import { useGetCannectPosts } from '@cannect/services/resources/strapi'

/**
 * A home do Novo Marketplace consome apenas os posts do blog. As chamadas de prescritores em
 * destaque e de marcas ativas saíram junto com as seções "Médicos parceiros" e "Marcas
 * selecionadas", que não existem no protótipo novo.
 */
export const useHome = () => {
  const { data: postsData } = useGetCannectPosts({})

  const postsList = (postsData as any)?.posts

  return { postsList }
}
